<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>Liste des personnages</span></h1>
<p class="P_Glossary"> </p>
<p class="P_Glossary"> </p>
<p class="P_Glossary"><span style=" font-size: 0.93em;">FAMILLE ORWELL :</span></p>
<p class="P_Glossary">Lord Caspian Orwell, mari de Lady Cynthia Orwell</p>
<p class="P_Glossary">Caspian a du surnaturel en lui et est capable de magie.</p>
<p class="P_Glossary">Cynthia fait partie du peuple Fey. Elle possède une force surhumaine et d’autres compétences.</p>
<p class="P_Glossary">Enfants (dans l’ordre de naissance) :</p>
<p class="P_Glossary">James, marié à Ellie (Magicienne)</p>
<p class="P_Glossary">James a une force surhumaine.</p>
<p class="P_Glossary">Enfant : une fille (Prophétesse)</p>
<p class="P_Glossary">James et Ellie possèdent une auberge.</p>
<p class="P_Glossary">Kevin, marié à Luke (moitié humain, moitié incube)</p>
<p class="P_Glossary">Kevin a une force surhumaine.</p>
<p class="P_Glossary">Alice, mariée à Mernon (Le Noir, célèbre assassin)</p>
<p class="P_Glossary">Alice a une force surhumaine.</p>
<p class="P_Glossary">Enfants : 2 filles, 2 garçons</p>
<p class="P_Glossary">May</p>
<p class="P_Glossary">Brennan</p>
<p class="P_Glossary">Terrian</p>
<p class="P_Glossary">Broden</p>
<p class="P_Glossary">Diana (Apothicaire, pratique un peu la magie)</p>
<p class="P_Glossary">Démétrius</p>
<p class="P_Glossary">Richard (Magicien, garde de la Reine, décédé)</p>
<p class="P_Glossary">Médiatrice familiale</p>
<p class="P_Glossary">Ophélia (Prophétesse)</p>
<p class="P_Glossary">Entretient une relation avec Frederick Pasley</p>
<p class="P_Glossary">Médiatrice familiale</p>
<p class="P_Glossary">Rebecca, mariée à Emily (moitié humaine, moitié Ondine)</p>
<p class="P_Glossary">Rebecca et Emily sont des escrimeuses.</p>
<p class="P_Glossary">Rebecca est la sœur jumelle de Pratchett.</p>
<p class="P_Glossary">Pratchett</p>
<p class="P_Glossary">Frère jumeau de Rebecca</p>
<p class="P_Glossary">Kraven</p>
<p class="P_Glossary">Troisième benjamin</p>
<p class="P_Glossary">Cécilia, mariée à Bérados (moitié humain, moitié Troll)</p>
<p class="P_Glossary">Cécilia a une force surhumaine</p>
<p class="P_Glossary">Enfant : Mabel</p>
<p class="P_Glossary">Sebastian (Cadet, Élu magique, Magicien élémentaire de la Terre)</p>
<p class="P_Glossary"> </p>
<p class="P_Glossary"><span style=" font-size: 0.93em;">FAMILLE ROYALE :</span></p>
<p class="P_Glossary">Le Roi Harris et la Reine Anne</p>
<p class="P_Glossary">Enfant : le Prince Turren</p>
<p class="P_Glossary">Cousin de Roi Harris : Lord Frederick Pasley</p>
<p class="P_Glossary">Frère du Roi Harris : L’ancien Roi Alchone qui vit en exil.</p>
<p class="P_Glossary">Ils ont tous des pouvoirs magiques.</p>
<p class="P_Glossary"> </p>
<p class="P_Glossary"><span style=" font-size: 0.93em;">GARDES ROYAUX :</span></p>
<p class="P_Glossary">Le Capitaine Pembrost</p>
<p class="P_Glossary">Le Lieutenant Adams</p>
<p class="P_Glossary">Le Sergent Hooper</p>
<p class="P_Glossary">Le Sergent Vendrix</p>
<p class="P_Glossary">Le Sergent Bradley</p>
<p class="P_Glossary">Le Sergent Thimbly</p>
<p class="P_Glossary">Sonny</p>
<p class="P_Glossary"> </p>
<p class="P_Glossary"><span style=" font-size: 0.93em;">DIFFÉRENTS MAGICIENS :</span></p>
<p class="P_Glossary">Margaret</p>
<p class="P_Glossary">Lord Harold Bast</p>
<p class="P_Glossary">Trey Ausher (également aubergiste)</p>
<p class="P_Glossary"> </p>
<p class="P_Glossary"><span style=" font-size: 0.93em;">CLIENTS DE LA LIBRAIRIE D’HAROLD :</span></p>
<p class="P_Glossary">Mr Jenkins</p>
<p class="P_Glossary">Mme Crane</p>
<p class="P_Glossary"> </p>
<p class="P_Glossary"><span style=" font-size: 0.93em;">RIVAUX</span>—Tous formés à la magie, avec Lord Orwell, par Maître Uvel</p>
<p class="P_Glossary">Trenton Keyes</p>
<p class="P_Glossary">Dalia</p>
<p class="P_Glossary">Féroas</p>
<p class="P_Glossary"> </p>
<p class="P_Glossary"><span style=" font-size: 0.93em;">NOTABLES DE LARNLYON :</span></p>
<p class="P_Glossary">Earl Grenwish</p>
<p class="P_Glossary">Lord Ulani</p>
<p class="P_Glossary">Lord Piadas : Ambassadeur d’Anerith, présent en ce moment à Larnlyon à cause du vol de l’amulette.</p>
<p class="P_Glossary"> </p>
<p class="P_Glossary"><span style=" font-size: 0.93em;">PAYS :</span></p>
<p class="P_Glossary">Larnlyon:</p>
<p class="P_Glossary">Gouverné par le Roi Harris et la Reine Anne.</p>
<p class="P_Glossary">Capitale : Trellium</p>
<p class="P_Glossary"> </p>
<p class="P_Glossary"><span style=" font-size: 0.93em;">AUTRES VILLES :</span></p>
<p class="P_Glossary">Cern—Abrite la Rangée des Magiciens, où vivent James, Ellie et Lord Trey Ausher.</p>
<p class="P_Glossary">Bruwen—Où vivent Kevin, Luke, Margaret, et Harold</p>
<p class="P_Glossary">Anerith</p>
<p class="P_Glossary">Ancien roi : Le Roi Orsen</p>
<p class="P_Glossary">Jesaro:</p>
<p class="P_Glossary">Pays anarchique où réside la Confrérie des Assassins.</p>
<p class="P_Glossary">Territoires Saints :</p>
<p class="P_Glossary">Pays où toute magie est bannie.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?4767d2b1